import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { quoteDirection } from "../../../quote/quote-form/quote-direction.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { Chip } from "primeng/chip";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-quote-direction-select",
  templateUrl: "./quote-direction-select.component.html",
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, Chip, FormsModule],
})
export class QuoteDirectionSelectComponent implements OnInit {
  public readonly directionChange = output<string>();
  @Input() public direction = null;
  public readonly disabled = input(false);
  public readonly isAllAvailable = input(true);
  public readonly showClear = input(false);

  public subscription = new Subscription();
  public directionList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildDirectionList();
  }

  public onDirectionChange(event) {
    this.directionChange.emit(event.value);
  }

  public clearDirection() {
    this.direction = null;
    this.directionChange.emit(null);
  }

  public getDirectionLabel(direction: string): string {
    return (
      this.directionList.find((item) => item.value === direction)?.label ?? ""
    );
  }

  private buildDirectionList() {
    if (this.isAllAvailable()) {
      this.directionList.push({
        label: "Directions",
        value: null,
      });
    }
    Object.keys(quoteDirection).map((key) => {
      this.directionList.push({
        label: key,
        value: quoteDirection[key],
      });
    });
  }
}
